import { useContext } from "react";
import { AuthContext } from "../firebaseio/AuthContext";
import { SettingRow } from "./SettingRow";

export function ProfileSettings(): JSX.Element {
  const auth = useContext(AuthContext);

  return (
    <div>
      <SettingRow label="Email Address" description={auth?.email ?? "—"} />
      <SettingRow label="User ID" description={auth?.uid ?? "—"} />
    </div>
  );
}
